import * as yup from 'yup';

export const prioridadIncidenciaSchema = yup.object({
  nombre: yup
    .string()
    .required('El campo nombre es requerido')
    .max(50, 'El campo nombre debe tener un máximo de 50 caracteres'),
  descripcion: yup
    .string()
    .required('El campo descripcion es requerido')
    .max(50, 'El campo nombre debe tener un máximo de 50 caracteres'),
  estado: yup
    .boolean()
    .required('El campo estado es requerido')
    .typeError('El campo estado debe ser un booleano'),
});

export const tipodIncidenciaSchema = yup.object({
  nombre: yup
    .string()
    .required('El campo nombre es requerido')
    .max(50, 'El campo nombre debe tener un máximo de 50 caracteres'),
  descripcion: yup
    .string()
    .required('El campo descripcion es requerido')
    .max(50, 'El campo nombre debe tener un máximo de 50 caracteres'),
  estado: yup
    .boolean()
    .required('El campo estado es requerido')
    .typeError('El campo estado debe ser un booleano'),
});
